import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { ReactKit } from '@team/react';
import { RootComponent } from '../../../../services/root-component';
import { Title } from '../../../../typography/title';
import { Subheadline } from '../../../../typography/subheadline';
import { HeaderProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef(function Component<T>(
  { multiline = false, children, subtitle, aside, ...props }: HeaderProps<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <RootComponent
      {...props}
      Component="header"
      baseClassName={clsx(css.host, { [css.multiline]: multiline })}
      ref={forwardedRef}
    >
      <div className={css.main}>
        <Title level={3} weight={1} className={css.text}>
          {children}
        </Title>

        {ReactKit.hasNode(subtitle) && (
          <Subheadline
            level={2}
            weight={3}
            className={clsx(css.subtitle, css.text)}
          >
            {subtitle}
          </Subheadline>
        )}
      </div>

      {ReactKit.hasNode(aside) && <div className={css.aside}>{aside}</div>}
    </RootComponent>
  );
});
